<template>
  <div
    class="time-bar"
    ref="container"
    @mousemove="handleTimeBarMove"
    @mouseleave="handleTimeBarOut"
    @click="handleTimeBarClick">
    <div class="buffer" :style="getBufferStyles()"></div>
    <div class="progress" :style="getProgressStyles()"></div>
    <div class="handler" :style="getHandlerStyles()" @mousedown="handleHandlerMouseDown"></div>
  </div>
</template>

<style lang="scss" scoped>

.time-bar {
  position: relative;
  flex: 1 1 auto;
  height: 0.25rem;
  background: var(--color--outlines);
}

.progress,
.buffer {
  position: absolute;
  height: 100%;
}

.progress {
  background: var(--color--action);
}

.buffer {
  background: var(--color--secondary);
  opacity: 0.5;
}

.handler {
  position: absolute;
  border-radius: 100%;
  width: 1rem;
  height: 1rem;
  transform: translate(-50%, -0.375rem);
  background: #248F79;
  cursor: pointer;
  user-select: none;
}

</style>

<script>
import range from '@/helpers/range'

export default {
  props: {
    current: {
      type: Number,
      default: 25
    },
    buffered: {
      type: Number,
      default: 50
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 100
    }
  },
  methods: {
    getProgressStyles () {
      const x = range.from(this.current, this.start, this.end)
      return {
        width: `${(x * 100)}%`
      }
    },
    getBufferStyles () {
      const x = range.from(this.buffered, this.start, this.end)
      return {
        width: `${(x * 100)}%`
      }
    },
    getHandlerStyles () {
      const x = range.from(this.current, this.start, this.end)
      return {
        left: `${(x * 100)}%`
      }
    },
    handleTimeBarOut () {
      this.$emit('out')
    },
    handleTimeBarMove (e) {
      const { left, right, top } = this.$refs.container.getBoundingClientRect()
      // From screen coordinates to time values.
      const time = range.fromTo(
        e.clientX,
        left,
        right,
        this.start,
        this.end
      )
      this.$emit('over', { time, x: range.clamp(e.clientX, left, right), y: top })
    },
    handleTimeBarClick (e) {
      const { left, right, top } = this.$refs.container.getBoundingClientRect()
      // From screen coordinates to time values.
      const time = range.clamp(range.fromTo(
        e.clientX,
        left,
        right,
        this.start,
        this.end
      ), this.start, this.buffered)
      this.$emit('over', { time, x: range.clamp(e.clientX, left, right), y: top })
      this.$emit('change', time)
    },
    handleHandlerMouseUp (e) {
      window.removeEventListener('mousemove', this.handleHandlerMouseMove)
      window.removeEventListener('mouseup', this.handleHandlerMouseUp)
    },
    handleHandlerMouseMove (e) {
      const { left, right, top } = this.$refs.container.getBoundingClientRect()
      // From screen coordinates to time values.
      const time = range.clamp(range.fromTo(
        e.clientX,
        left,
        right,
        this.start,
        this.end
      ), this.start, this.buffered)
      this.$emit('over', { time, x: range.clamp(e.clientX, left, right), y: top })
      this.$emit('change', time)
    },
    handleHandlerMouseDown (e) {
      // We allow movement only if the mouse button down is
      // the left button.
      if (e.button === 0) {
        window.addEventListener('mousemove', this.handleHandlerMouseMove)
        window.addEventListener('mouseup', this.handleHandlerMouseUp)
      }
    }
  }
}
</script>
